import React from "react";

const useDialog = () => {
    const [isOpen, setIsOpen] = React.useState(false);

    const close = () => setIsOpen(false);
    const open = () => setIsOpen(true);

    return {
        isOpen,
        close,
        open,
    }
}

export default useDialog;